@if (data()) {
  <div class="row">
    <div class="col-lg-6">
      <div class="w-100 mb-2">
        <div class="input-group has-validation">
          <div class="form-floating" [class.is-invalid]="!tagNameInput.validity.valid">
            <input type="text" class="form-control" [class.is-invalid]="!tagNameInput.validity.valid"
              id="custom_tag_name" aria-describedby="custom_tag_validation_feedback" #tagNameInput
              (change)="tagNameInput.value = tagNameInput.value.trim()" [attr.disabled]="disabled() ? true: null">
            <label for="custom_tag_name">Tag Name</label>
          </div>
          <div class="form-floating" [class.is-invalid]="!tagValueInput.validity.valid">
            <input type="text" class="form-control" [class.is-invalid]="!tagValueInput.validity.valid"
              id="custom_tag_value" aria-describedby="custom_tag_validation_feedback" #tagValueInput
              (change)="tagValueInput.value = tagValueInput.value.trim()" [attr.disabled]="disabled() ? true: null">
            <label for="custom_tag_value">Tag Value</label>
          </div>
          <button type="button" class="btn btn-outline-dark bg-syk-grey" (click)="addTag(tagNameInput, tagValueInput)"
            [attr.disabled]="disabled() ? true: null">
            <i class="bi bi-plus-circle"></i> Add
          </button>
          <div class="invalid-feedback" id="custom_tag_validation_feedback">
            {{tagNameInput.validationMessage}}
            {{tagValueInput.validationMessage}}
          </div>
        </div>
      </div>
    </div>
    @if (data()!.tags.length > 0) {
      <div class="col-lg-6">
        <div class="d-flex align-content-start flex-wrap w-100">
          @for (tag of data()!.tags; track tag.name) {
            <div class="d-flex align-items-baseline border rounded bg-syk-grey me-2 mb-2 p-1">
              {{tag.name}}:{{tag.value}} <button type="button" class="btn btn-sm p-0 m-0 ms-1" [attr.disabled]="disabled() ? true: null" (click)="removeTag($index)"><i class="bi bi-trash-fill"></i></button>
            </div>
          }
        </div>
      </div>
    }
  </div>
}
